import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import {
  ICreateCredentialDto,
  IUpdateCredentialDto,
} from 'common/src/types/credential.dtos';
import { ICredential, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getCredential = async (id: string): Promise<ICredential> =>
  await getRequest(`${API_BASE_PATHS.CREDENTIALS}/${id}`);

export const getCredentials = async (
  params?: DataQueryParams,
): Promise<IPage<ICredential>> =>
  await getRequest(API_BASE_PATHS.CREDENTIALS, formatQueryParams(params));

export const addCredential = async (
  body: ICreateCredentialDto,
): Promise<string> => await postRequest(API_BASE_PATHS.CREDENTIALS, {}, body);

export const updateCredential = async (
  id: string,
  body: IUpdateCredentialDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.CREDENTIALS}/${id}`, {}, body);

export const deleteCredential = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.CREDENTIALS}/${id}`);

export const changeCredentialPassword = async (
  id: string,
  body: { newPassword: string },
): Promise<void> =>
  await postRequest(
    `${API_BASE_PATHS.CREDENTIALS}/${id}/changePassword`,
    {},
    body,
  );
